// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/approval_flow_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { ApprovalFlowService } from "./approval_flow_service_pb";

/**
 * GetApprovalFlowScreen returns everything the approval-flow admin screen
 * needs in one call: the per-process configuration plus the directory of
 * members that can be designated as approvers. This is a read-only BFF
 * aggregation: it fans out to the backend
 * ApprovalFlowService.GetApprovalFlowSettings and
 * UserDirectoryService.ListMembers and shapes the result for the screen.
 *
 * @generated from rpc bffuser.v1.ApprovalFlowService.GetApprovalFlowScreen
 */
export const getApprovalFlowScreen = ApprovalFlowService.method.getApprovalFlowScreen;

/**
 * SaveApprovalFlow overwrites the approval-flow configuration for one
 * business process. Uses optimistic locking via expected_updated_at.
 *
 * @generated from rpc bffuser.v1.ApprovalFlowService.SaveApprovalFlow
 */
export const saveApprovalFlow = ApprovalFlowService.method.saveApprovalFlow;

/**
 * ListApprovalModeSwitchHistory returns the history of automatic
 * approval-mode switches for the given business process.
 *
 * @generated from rpc bffuser.v1.ApprovalFlowService.ListApprovalModeSwitchHistory
 */
export const listApprovalModeSwitchHistory = ApprovalFlowService.method.listApprovalModeSwitchHistory;

/**
 * SaveAutoBidRule persists the buy/sell 自動入札ルール pair to every area
 * in area_codes (upsert, last-write-wins). A single area_codes entry is a
 * per-area edit (AC-02); multiple entries are a 全エリア一括編集 (AC-03).
 *
 * @generated from rpc bffuser.v1.ApprovalFlowService.SaveAutoBidRule
 */
export const saveAutoBidRule = ApprovalFlowService.method.saveAutoBidRule;
